import React, { useState, useEffect } from 'react';
import { SimulationRoomProps } from '../types';
import { SimulationRoom } from './SimulationRoom';
import { PwaSimulationRoom } from './PwaSimulationRoom';
import { shouldUsePwaSimulation } from '../utils/deviceDetection';

/**
 * SimulationDispatcher
 * Seamlessly resolves whether to render the desktop Website SimulationRoom
 * or the dedicated PwaSimulationRoom based on device form factor, display-mode
 * (standalone PWA vs WebView vs standard desktop website), and user overrides.
 */
export const SimulationDispatcher: React.FC<SimulationRoomProps> = (props) => {
  const [isPwa, setIsPwa] = useState<boolean>(() => shouldUsePwaSimulation());

  useEffect(() => {
    const handleUpdate = () => {
      setIsPwa(shouldUsePwaSimulation());
    };

    window.addEventListener('resize', handleUpdate);
    window.addEventListener('orientationchange', handleUpdate);

    let mql: MediaQueryList | null = null;
    if (typeof window !== 'undefined' && window.matchMedia) {
      mql = window.matchMedia('(display-mode: standalone)');
      if (mql?.addEventListener) {
        mql.addEventListener('change', handleUpdate);
      }
    }

    return () => {
      window.removeEventListener('resize', handleUpdate);
      window.removeEventListener('orientationchange', handleUpdate);
      if (mql?.removeEventListener) {
        mql.removeEventListener('change', handleUpdate);
      }
    };
  }, []);

  if (isPwa) {
    return <PwaSimulationRoom {...props} />;
  }

  return <SimulationRoom {...props} />;
};

